var BST;
(function (BST) {
  var SettingDrv = BST.SettingDrv = (function () {
    // var SEXS = [
    //    {cd: "-1", nm: "すべて"}
    //    ,{ cd: 1, nm: "男" }
    //    , { cd: 2, nm: "女" }
    // ];

    function SettingDrv (parent, options) {
      var _self = this;

      parent = parent || 'body';
      var opt = this.opt = options || {};
      this._callbackCreate = opt.callbackCreate;
      this._callbackUpdate = opt.callbackUpdate;
      this._callbackDelete = opt.callbackDelete;
      this._callbackCsv = opt.callbackCsv;

      this.create(parent);
      this.createTable([], [], [], []);
    }

    SettingDrv.prototype.setData = function (datas, orgs, sexs, nts, dnum, cnum) {
      this._datas = datas || [];
      this._orgs = orgs || [];
      this._sexs = sexs || [];
      this._nts = nts || [];
      this._dnum = dnum === undefined || dnum === null ? '-' : dnum;
      this._cnum = cnum === undefined || cnum === null ? '-' : cnum;

      this.dcnum.html('登録済ドライバー数&nbsp' + dnum + '名（上限' + cnum + '名）');

      if (dnum > cnum) {
        // 多いので無効
        this.disableNewBtn(true);
      } else {
        this.disableNewBtn(false);
      }
    };

    SettingDrv.prototype.create = function (parent) {
      var _self = this;

      var base = this.base = $('<div>').addClass('setting-drv').appendTo(parent);

      var header = $('<div>').addClass('header').appendTo(base);

      var row1 = $('<div>').addClass('row').appendTo(header);
      this.btnNew = $('<span>').addClass('btn-new').text('新規作成').appendTo(row1)
        .on('click', function () {
          if (_self._disableNewBtn) return;
          if (_self._callbackCreate) _self._callbackCreate(_self._orgs, _self._nts);
        });
      $('<span>').addClass('label').html('ドライバー設定').appendTo(row1);
      // this.dcnum = $("<div>").addClass("count").html("登録済ドライバー数&nbsp" + "-" + "名（上限" + "-" + "名）").appendTo(row1);
      var panel1 = $('<div>').addClass('count').appendTo(row1);
      $('<span>').addClass('label').text('契約内').appendTo(panel1);
      this.dcnum = $('<span>').html('登録済ドライバー数&nbsp' + '-' + '名（上限' + '-' + '名）').appendTo(panel1);

      var row2 = $('<div class="row"> ').appendTo(header);
      $("<input type='password' name='dummypass' style='visibility: hidden; position: absolute;' />").addClass('search').appendTo(row2);
      this.search = $('<input>').addClass('search').attr('autocomplete', 'off').attr('placeholder', 'フリーワード検索').appendTo(row2);
      // eslint-disable-next-line no-empty
      if (!BST.Com.isCsv()) {

      } else {
        var csv = this.csv = $('<div>').addClass('csv').appendTo(row2);
        csv.on('click', function () {
          _self._callbackCsv();
        });
      }
    };

    // テーブル作成
    SettingDrv.prototype.createTable = function (drvs, orgs, sexs) {
      var _self = this;

      // テーブル
      if (!this.table) {
        this.table = $('<table>').addClass('table').appendTo(this.base);
      } else {
        this.table.empty();
      }
      var table = this.table;
      var header = $('<thead>').addClass('scrollHead').appendTo(table);
      var tr = $('<tr> ').appendTo(header);
      $('<td>').addClass('col0').addClass('label0').text('').appendTo(tr);
      $('<td>').addClass('col1').addClass('label').text('所属拠点').appendTo(tr);
      $('<td>').addClass('col2').addClass('label').text('ドライバー名').appendTo(tr);
      $('<td>').addClass('col3').addClass('label').text('性別').appendTo(tr);
      $('<td>').addClass('col5').addClass('label').text('カードID').appendTo(tr);
      $('<td>').addClass('col4').addClass('label').text('').appendTo(tr);

      // ハッシュ
      var orgMap = {};
      for (var i = 0; i < orgs.length; i++) {
        orgMap[orgs[i].cd] = orgs[i];
      }

      var sexMap = {};
      for (i = 0; i < sexs.length; i++) {
        sexMap[sexs[i].id] = sexs[i];
      }

      var body = $('<tbody>').addClass('scrollBody').appendTo(table);
      // 1行分
      for (i = 0; i < drvs.length; i++) {
        var d = drvs[i];

        // 所属
        var org = orgMap[d.ocd] || { nm: '' };
        // 性別
        var sx = sexMap[d.sx] || { nm: '' };

        // var tr = $("<tr>").appendTo(table);
        // $("<td>").text("長谷川"+i).appendTo(tr);

        tr = $('<tr class="tr"> ').data('data', d).appendTo(_self.table);
        $('<td>').addClass('col0').addClass('item').addClass('item0').text(i + 1).appendTo(tr);
        $('<td>').addClass('col1').addClass('item').text(org.nm).appendTo(tr);
        $('<td>').addClass('col2').addClass('item').text(d.nm).appendTo(tr);
        $('<td>').addClass('col3').addClass('item').addClass('item3').text(sx.nm).appendTo(tr);
        $('<td>').addClass('col5').addClass('item').text(d.ni).appendTo(tr);
        var btns = $('<td>').addClass('col4').addClass('item').appendTo(tr);
        $('<span>').addClass('btn-edit').text('編集').appendTo(btns)
          .on('click', function () {
            var _d = $(this).parent().parent().data('data');
            if (_self._callbackUpdate) {
              _self._callbackUpdate(_d, _self._orgs, _self._nts);
            }
          });
        $('<span>').addClass('btn-delete').text('削除').appendTo(btns)
          .on('click', function () {
            var _d = $(this).parent().parent().data('data');
            if (_self._callbackDelete) {
              _self._callbackDelete(_d);
            }
          });
      }// end of for
      if (drvs.length > 0) {
        this.table.exTableFilter(this.search
          , {
            onFilteringEnd: function (api) {
              _self.resetNumber();
            }
          }
        );
      }
      this.search.trigger('change');
    };

    SettingDrv.prototype.update = function (drvs, orgs, sexs, nts, dnum, cnum) {
      this.setData(drvs, orgs, sexs, nts, dnum, cnum);
      this.createTable(drvs, orgs, sexs);
    };

    SettingDrv.prototype.resetNumber = function () {
      var no = 1;

      this.table.find('.scrollBody').find('.tr').each(function (i, elem) {
        var $tr = $(elem);

        // console.debug($tr.css('display'));
        if ($tr.css('display') !== 'none') {
          var $no = $tr.find('.col0');
          $no.text(no);
          no++;
        }
      });
    };

    SettingDrv.prototype.disp = function (b) {
      if (b) {
        this.base.show();
      } else {
        this.base.hide();
      }
    };

    SettingDrv.prototype.disableNewBtn = function (b) {
      // if (b) {
      //    this._disableNewBtn = true;
      //    this.btnNew.addClass("disable");
      // }
      // else {
      //    this._disableNewBtn = false;
      //    this.btnNew.removeClass("disable");
      // }
    };

    return SettingDrv;
  })();
})(BST || (BST = {}));
